var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { AdminProductBuilderList } from '../builders/adminProductList-builder';
import { AdminProductBuilder } from '../builders/adminProduct-builder';
import { AdminProductAlternativeBuilderList } from '../builders/adminProductAlternativeList-builder';
import { AdminProductAlternativeBuilder } from '../builders/adminProductAlternative-builder';
import { AdminLotBuilder } from '../builders/adminLot-builder';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class AdminProductsApiService {
    constructor(authenticatedApi) {
        this.authenticatedApi = authenticatedApi;
    }
    listProductsAdmin() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.authenticatedApi.get(`/adminproduct/list_products`).toPromise();
            return data.products.map(product => AdminProductBuilder.buildAdminProduct(product));
        });
    }
    list(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.get(`/adminproduct/product_list`, payload).toPromise();
            return AdminProductBuilderList.buildAdminProductList(response);
        });
    }
    listAll() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.get(`/adminproduct/all`).toPromise();
            return response.products;
        });
    }
    add(adminProduct) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`/adminproduct/product`, adminProduct).toPromise();
            return AdminProductBuilder.buildAdminProduct(response.product);
        });
    }
    update(adminProduct) {
        return __awaiter(this, void 0, void 0, function* () {
            const { id } = adminProduct;
            const response = yield this.authenticatedApi.put(`/adminproduct/product/${id}`, adminProduct).toPromise();
            return AdminProductBuilder.buildAdminProduct(response.product);
        });
    }
    listLots() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.get(`/adminproduct/list_lots`).toPromise();
            return response.lots.map(lot => AdminLotBuilder.buildAdminLot(lot));
        });
    }
    getProductInfo(adminProductID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.get(`/adminproduct/info/${adminProductID}`).toPromise();
            return AdminProductBuilder.buildAdminProductInfo(response);
        });
    }
    updateProductInfo(adminProductInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const { id_product } = adminProductInfo;
            const response = yield this.authenticatedApi.put(`/adminproduct/info/${id_product}`, adminProductInfo).toPromise();
            return AdminProductBuilder.buildAdminProductInfo(response);
        });
    }
    createProductInfo(adminProductInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`/adminproduct/info`, adminProductInfo).toPromise();
            return AdminProductBuilder.buildAdminProductInfo(response);
        });
    }
    listProductsAlternatives(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.get(`/adminproduct/products_alternatives_list`, payload).toPromise();
            return AdminProductAlternativeBuilderList.buildAdminProductAlternativeList(response);
        });
    }
    listAllProductsAlternatives() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.get(`/adminproduct/products_alternatives_list`).toPromise();
            return response.products_alternatives_list;
        });
    }
    createProductAlternative(adminProductAlternative) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`/adminproduct/product_alternative`, adminProductAlternative).toPromise();
            return AdminProductAlternativeBuilder.buildAdminProductAlternative(response);
        });
    }
    getProductAlternative(adminProductAlternativeID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.get(`/adminproduct/product_alternative/${adminProductAlternativeID}`).toPromise();
            return AdminProductAlternativeBuilder.buildAdminProductAlternative(response);
        });
    }
    updateProductAlternative(adminProductAlternative) {
        return __awaiter(this, void 0, void 0, function* () {
            const { id } = adminProductAlternative;
            const response = yield this.authenticatedApi.put(`/adminproduct/product_alternative/${id}`, adminProductAlternative).toPromise();
            return AdminProductAlternativeBuilder.buildAdminProductAlternative(response);
        });
    }
    deleteProductAlternative(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.delete(`adminproduct/product_alternative/${id}`).toPromise();
            return response;
        });
    }
    cloneExtraInstructions(id_extra) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`adminproduct/clone_extra_info/${id_extra}`).toPromise();
            return response;
        });
    }
    cloneTerminalInstructions(in_terminal, out_terminal) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`adminproduct/clone_terminal_info/${in_terminal}/${out_terminal}`).toPromise();
            return response;
        });
    }
}
AdminProductsApiService.ɵfac = function AdminProductsApiService_Factory(t) { return new (t || AdminProductsApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
AdminProductsApiService.ɵprov = i0.ɵɵdefineInjectable({ token: AdminProductsApiService, factory: AdminProductsApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(AdminProductsApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=admin-products-api.service.js.map